import { useQuery } from '@provision/graphql-client';
import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { GET_WORKFLOW_VERSIONS_QUERY } from 'src/graphql/entities/workflow/workflow.operations';
import { GetWorkflowVersionsQuery } from 'src/graphql/entities/workflow/workflow.types';
import { QueryVariables } from 'src/graphql/types';
import { useNotifications } from 'src/utils/hooks';

export const useWorkflowVersions = ({
  workflowId,
  includeDeleted = false,
}: {
  workflowId?: string | null;
  includeDeleted?: boolean;
}) => {
  const { showErrorAlert } = useNotifications();

  const {
    data,
    loading,
    error,
    refetch: refetchWorkflowVersions,
  } = useQuery<GetWorkflowVersionsQuery, QueryVariables>(GET_WORKFLOW_VERSIONS_QUERY, {
    variables: {
      params: {
        filters: workflowId
          ? [
              {
                attribute: 'workflowId',
                operator: '=',
                value: workflowId,
              },
            ]
          : [],
        includeDeleted,
        sorting: [{ attribute: 'version', desc: true }],
      },
    },
    skip: isNullish(workflowId),
    onError: (fetchError) => {
      console.error(fetchError);
      showErrorAlert('Failed to load workflow versions. Please try again.');
    },
  });

  const workflowVersions = useMemo(
    () => data?.getWorkflowVersion?.records ?? [],
    [data?.getWorkflowVersion?.records],
  );

  return {
    workflowVersions,
    loading,
    error,
    refetchWorkflowVersions,
  };
};
